import jQuery from 'jquery';

const widget = jQuery.widget('ep.slideoutWidget', {
	options: {
		visible: true,
		loading: false,
		closeable: true,
		customClass: undefined,
		maxWidth: undefined,
		width: undefined,
		url: undefined,
		title: '',
		triggerElement: undefined,
		classes: {
			widget: 'slideout-widget',
			widgetExtraClasses: [],
			slideout: '__slideout',
			titlebar: '__titlebar',
			close: '__close',
			content: '__content',
			loading: '__loading'
		},
		states: {
			loading: '__loading',
		},
		content: $('<div/>'),
		listeners: {
			onClose: function () {
			}
		}
	},
	_create: function () {
		this._createStructure();
		this._bindListeners();
		this._refresh();
	},
	_createStructure: function () {
		const element = this.element;

		const options = this.options;
		const classes = options.classes;

		element.addClass(classes.widget);
		classes.widgetExtraClasses.forEach((extraClass) => {
			element.addClass(extraClass);
		});

		const titlebarElm = jQuery(`<div class="${classes.widget + classes.titlebar}">${options.title}</div>`);
		element.append(titlebarElm);

		const closeElm = jQuery(`<button class="${classes.widget + classes.close}" aria-label="${__('overlays.labels.close')}"><i class="fa fa-times" aria-hidden="true"></i></button>`);
		element.append(closeElm);

		const contentElm = jQuery(`<div class="${classes.widget + classes.content}"></div>`);
		element.append(contentElm);

		const loadingElm = jQuery(`<div class="${classes.widget + classes.loading}"></div>`);
		element.append(loadingElm);

		this._elmCache = {
			titlebar: titlebarElm,
			close: closeElm,
			content: contentElm,
			loading: loadingElm
		};

		this._setOption('content', options.content);
	},
	_setOptions: function () {
		// _super and _superApply handle keeping the right this-context
		this._superApply(arguments);
		this._refresh();
	},
	_setOption: function (key, value) {
		if (key === 'content') {
			this._beforeLoadingContent();
			const contentElm = this._elmCache.content;
			contentElm.children().detach();
			contentElm.append(value);
			this._afterLoadingContent();

		} else if (key === 'url') {
			this.reloadUrl();
		}
		this._super(key, value);
	},
	_beforeLoadingContent: function(){},
	_afterLoadingContent: function(){},
	reloadUrl: function(){
		const component = this;
		component._setOption('loading', true);
		$.ajax({
			type: "GET",
			url: this.options.url,
			success: function (result) {
				component._setOption('content', result);
				component._setOption('loading', false);
			}
		});
	},
	_bindListeners: function () {
		const closeButton = this.element.find(`.${this.options.classes.widget + this.options.classes.close}`)[0];
		closeButton.addEventListener('click', () => {
			this.close();
		});
		this.element[0].addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				this.close();
			}
		});
		this.element[0].addEventListener('click', (event) => {
			if (event.target === this.element[0]) {
				this.close();
			}
		});

	},
	close: function () {
		if (!this.options.closeable) return;
		this.element[0].close();
		this.options.listeners.onClose();
		this.options.triggerElement?.focus();
	},
	_refresh: function () {
		const options = this.options;
		const states = options.states;

		const element = this.element;

		if (options.loading) {
			element.addClass(states.loading);
		} else {
			element.removeClass(states.loading);
		}

		if (typeof options.customClass !== 'undefined') {
			element.addClass(options.customClass);
		}

		if (typeof options.maxWidth !== 'undefined') {
			element.find('.' + options.classes.slideout).eq(0).css('max-width', options.maxWidth);
		}

		if (typeof options.width !== 'undefined') {
			element.find('.' + options.classes.slideout).eq(0).css('width', options.width);
		}

		if (typeof options.url !== 'undefined') {
			this._setOption('url', options.url);
		}

		if (this.options.visible) {
			this.element[0].showModal();

		} else {
			this.element[0].close();
		}

		this._elmCache.titlebar.text(options.title);
	}
});

export {widget as widget};

export default function () {
	// Nothing to initialize
};
